import classNames from 'classnames';

const baseCtaClasses = classNames(
  'fixed bottom-0 left-0 right-0 p-6',
  'bg-gradient-to-b from-transparent to-black/30',
  'md:hidden'
);
export const ctaFadeIn = classNames(baseCtaClasses, 'animate-fade-in');

export const ctaFadeOut = classNames(baseCtaClasses, 'animate-fade-out');

export const ctaClasses = classNames(
  'w-full max-w-[550px] mx-auto text-center'
);
